import { Typography } from './mapping';

export const typography = Typography;
